import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { EventAttend, EventAttendSearch } from 'src/app/models/event';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-open-event',
  templateUrl: './open-event.component.html',
  styleUrls: ['./open-event.component.css']
})
export class OpenEventComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private eventService: EventService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    if(this.commonService.getIsMobile()) {
      this.router.navigate(['/m/openEvent'])
    }
  }
  eventType: string = 'OPEN_EVENT'
  user: User
  ngOnInit(): void {
    this.user = this.commonService.getUserInfo()
    if(this.user) {
      this.getEventAttendList()
    }
    window.addEventListener("scroll", (event) => {
      this.onscroll(event)
    });
  }
  checkToken() {
    if(!this.user) {
      alert("로그인 후 이용해 주세요")
      window.scrollTo(0, 0);
      this.router.navigate(['/login'], {queryParams: { returnUrl: '/openEvent' }})
    }
  }
  moveJoin() {
    window.scrollTo(0, 0);
    this.router.navigate(['/join'])
  }

  snsUrl: string
  eventAttend() {
    if(!this.user) {
      alert("로그인 후 이용해 주세요")
      window.scrollTo(0, 0);
      this.router.navigate(['/login'], {queryParams: { returnUrl: '/openEvent' }})
    } else {
      if(!this.snsUrl || this.snsUrl.length == 0) {
        return alert("게시물 링크를 입력해주세요")
      }
      this.eventService.addEventAttend(this.eventType, this.snsUrl, 'REG').subscribe(res => {
        if(res.resultCode == '8888') {
          alert(res.message)
        } else {
          this.toastr.success("정상적으로 등록 되었습니다.")
          this.snsUrl = null
          this.getEventAttendList()
        }
      })
    }
  }

  attendListSize: number = 0
  getEventAttendList() {
    let search = new EventAttendSearch()
    search.fromDate = null
    search.toDate = null
    search.rows = 100
    search.type = this.eventType
    search.statusList = ['REG', 'COM']
    this.spinner.show();
    this.eventService.getEventAttendList(search).subscribe(res => {
      this.spinner.hide()
      this.attendListSize = res.data.page.totalElements
    })
  }

  anchorId: string = 'oAnchorCont1'
  moveTab(anchorId: string) {
    const targetEl = document.getElementById(anchorId);
    if (targetEl) {
      targetEl.scrollIntoView({behavior:'smooth', block:'start'});
    }
  }

  logout(){
    this.authService.logout()
  }


  visible1: boolean = true
  visible2: boolean = false
  visible3: boolean = false
  onscroll(event: any){
    const viewportHeight = $(window).height(); // Viewport Height
    const scrolltop = $(window).scrollTop(); // Scroll Top
    const y1 = $('#oAnchorCont1').offset().top;
    const x1 = $('#oAnchorCont1').height();
    const y2 = $('#oAnchorCont2').offset().top;
    const x2 = $('#oAnchorCont2').height();
    const y3 = $('#oAnchorCont3').offset().top;
    const x3 = $('#oAnchorCont3').height();

    this.visible1 = ((y1 < (viewportHeight + scrolltop)) && (y1 > (scrolltop - x1 + 80)));
    this.visible2 = ((y2 < (viewportHeight + scrolltop)) && (y2 > (scrolltop - x2 + 80)));
    this.visible3 = ((y3 < (viewportHeight + scrolltop)) && (y3 > (scrolltop - x3 + 80)));
    if(this.visible1) {
      this.visible2 = false
      this.visible3 = false
    } else if(this.visible2) {
      this.visible3 = false
    }
  }

  openGuideWindow() {
    var width = 1400 //screen.availWidth - 150
    var height = 800 //screen.availHeight - 250
    var windowPopup = window.open('/guide', 'guideWindow', 'width='+width/13*11+',height='+height+',left='+width/13*4+',top=0,scrollbars=no');
    windowPopup.focus();
  }
}
